import BaseService from '../base';
import { ContractDocumentParams, ContractDocumentsApiProps, JobContract } from './types';

class Contract extends BaseService {
  getContractDocuments() {
    return {
      query: (id: number) => ({
        url: `contracts/${id}/documents`,
      }),
      transformResponse: (response: ContractDocumentsApiProps) => (
        Array.isArray(response) ? response : response?.documents || []
      ),
      providesTags: (
        _result: ContractDocumentsApiProps | undefined,
        _error: unknown,
        id: number,
      ) => (
        [{ type: this.tagType, id }, { type: 'Document', id: `contract-${id}` }]
      ),
    };
  }

  createContractDocument() {
    return {
      query: ({
        id,
        ...params
      }: ContractDocumentParams) => ({
        url: `contracts/${id}/documents`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: (
        _result: unknown,
        _error: unknown,
        { id, refresh_holder_only: refreshHolderOnly }: ContractDocumentParams,
      ) => (refreshHolderOnly
        ? []
        : [{ type: this.tagType, id: 'LIST' }, { type: 'Worker' }, { type: 'Contract', id }]),
    };
  }

  delete() {
    return {
      query: (id: number) => ({
        url: `/contracts/${id}`,
        method: 'delete',
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Worker' }, { type: 'Job' }],
    };
  }

  updateContract() {
    return {
      query: ({ id, ...params }: JobContract) => ({
        url: `/contracts/${id}`,
        method: 'PATCH',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Worker' }, { type: 'Contract' }, { type: 'Job' }],
    };
  }
}
export default new Contract('contracts', 'Contract');
